// Define Page Size Limit options in datatables
export const pageSizeOptions = [10, 20, 30, 50, 100];
